export default "__VITE_ASSET__BUXEtSmR__"